<template>
  <!-- Loading message when isLoading is true -->
  <div
    v-if="isLoading"
    class="d-flex justify-content-center align-items-center"
    style="height: 40vh"
  >
    <div class="custom-spinner" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>

  <!-- Error Handling -->
  <div v-if="!isLoading && errorMessage.length > 0" class="alert alert-danger">
    <strong>Erro!</strong> {{ errorMessage }}
  </div>
  <section>
    <!-- Display the child component with the survey -->
    <SurveyIntroduction  v-if="!isLoading && errorMessage.length === 0" :sections="sections"> </SurveyIntroduction>
  </section>
</template>

<script>
// import child component
import SurveyIntroduction from '@/components/home/SurveyIntroduction.vue';
export default {
  components: {
    SurveyIntroduction,
  },

  data() {
    return {
      sections: [], // Dictionary with unique section ids and descriptions
      isLoading: false, // Sets the Loading Spinner On and Off
      errorMessage: '', // Error message to display to the user
    };
  },

  created() {
    // load the survey from the backend when we mount
    this.loadSections();
  },

  methods: {
    async loadSections() {
      // Set the Loading Spinner On
      this.setLoading(true);
      // Dispatch the action to load the survey questions
      var loadMessage = await this.$store.dispatch('home/loadSections');

      // Check if the survey was loaded successfully
      if (loadMessage !== true) {
        this.errorHandling('Erro ao conectar à base de dados. Por favor tente novamente.');
      }

      this.sections = this.$store.getters['home/sections'];

      this.setLoading(false);
    },
    // Set the isLoading value
    setLoading(value) {
      this.isLoading = value;
    },

    // deal with error messages
    errorHandling(error) {
      this.errorMessage = error;

      if (this.errorMessage.length > 0) {
        //Scroll to the top of the page
        window.scrollTo({
          top: 0,
          behavior: 'smooth', // Scroll behavior
        });
      }
    },
  },
};
</script>
